import React, { useState } from "react";
import CTAWithArrow from "../../../../react-only-components/CTAWithArrow";
import RoutableNotEditableLink from "../../../../react-only-components/RoutableNotEditableLink";
import {
  TComponentDetailsProps,
  InnerComponentTypes,
} from "../../types/ContentHubSeriesDetails.type";
import ModalDialog from "../../../../react-only-components/ModalDialog/ModalDialog";
import InnerSplitModules from "../InnerSplitModules";
import InnerCards from "../InnerCards";
import Banner from "./Banner";
import "./styles.scss";

const ContentHubSeriesDetails = (props: TComponentDetailsProps) => {
  const model = props.component;
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const hasInnerComponents: boolean = !!(
    model?.innerComponents && model?.innerComponents.length
  );

  const showModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <article className={`component-details ${props.className}`}>
      {hasInnerComponents && (
        <ModalDialog
          isOpen={modalIsOpen}
          close={closeModal}
          className="series-features-modal"
        >
          {model.layoutType === InnerComponentTypes.Split ? (
            <InnerSplitModules components={model?.innerComponents ?? []} />
          ) : (
            <InnerCards components={model?.innerComponents ?? []} />
          )}
        </ModalDialog>
      )}
      <Banner component={model} className="" />
      <div className="component-details__content">
        <h2 className="component-details__title">{model?.title}</h2>
        <div
          className="component-details__text"
          dangerouslySetInnerHTML={{ __html: model?.description ?? '' }}
        />
        <div className="component-details__button-wrapper">
          {hasInnerComponents && (
            <pfe-cta pfe-priority="primary" class="component-details__button">
              <button onClick={showModal}>Discover more</button>
            </pfe-cta>
          )}
          {model?.button1?.label ? (
            <pfe-cta pfe-priority="primary" class="component-details__button">
              <RoutableNotEditableLink href={model?.button1.url}>
                {model?.button1?.label}
              </RoutableNotEditableLink>
            </pfe-cta>
          ) : null}
          {model?.button2?.label ? (
            <CTAWithArrow
              text={model?.button2?.label}
              href={model?.button2.url}
            />
          ) : null}
        </div>
      </div>
    </article>
  );
};

export default ContentHubSeriesDetails;
